import { assessmentKey } from './assessment.const';
import { AppStateWithAssessmentData as State } from './assessment.types';

const select = (state: State) => state[assessmentKey];

export const getError = (state: State) => select(state).error;
export const getAssessmentLoading = (state: State) => select(state).loading;
export const getIsRefetchingAssessment = (state: State) =>
  select(state).isRefetchingAssessment;
